<template>
  <BModal size="lg" body-class="p-5 rounded-lg" :visible="visible" hide-header hide-footer @hide="$emit('hide', true)">
    <div class="text-center">
      <img
        style="width: 160px"
        class="d-block mx-auto mb-4"
        :src="industry == 'cannabis' ? '/img/logos/apex-logo.png' : '/img/logos/bushel-logo.png'"
        :alt="industry == 'cannabis' ? 'Apex Logo' : 'Bushel44 Logo'"
      />

      <h1 class="font-weight-normal gradient-text">Congratulations!</h1>
      <p class="font-weight-bold text-dark mb-1">You have successfully signed up!</p>

      <div class="p-2 bg-light border rounded">
        <p class="m-0">Before you can continue your company must be approved.</p>
        <p class="m-0">You will receive an email once your company has been approved.</p>
        <BushelBtn class="btn-sm mt-3" variant="primary" outline @click="$emit('hide', true)"> Close </BushelBtn>
      </div>
    </div>
  </BModal>
</template>
<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["hide"],
  data() {
    return {
      industry: "cannabis",
    };
  },
};
</script>
<style>
.gradient-text {
  background: linear-gradient(to right, var(--success), var(--primary) 60%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
</style>
